import { AppNotification, NotificationPreference, NotificationType } from '../../domain/models/Notification';

export interface NotificationEntity {
  id: string;
  user_id: string;
  type: string;
  title: string;
  body: string;
  data: Record<string, string>;
  read: boolean;
  created_at: string;
}

export interface NotificationPreferenceEntity {
  id: string;
  user_id: string;
  notification_type: string;
  enabled: boolean;
}

export const notificationEntityToModel = (entity: NotificationEntity): AppNotification => {
  return {
    id: entity.id,
    userId: entity.user_id,
    type: entity.type as NotificationType,
    title: entity.title,
    body: entity.body,
    data: entity.data || {},
    read: entity.read,
    createdAt: new Date(entity.created_at),
  };
};

export const notificationPreferenceEntityToModel = (
  entity: NotificationPreferenceEntity
): NotificationPreference => {
  return {
    id: entity.id,
    userId: entity.user_id,
    notificationType: entity.notification_type as NotificationType,
    enabled: entity.enabled,
  };
};
